import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center py-24 px-4 sm:px-6 lg:px-8 text-gray-900 dark:text-white" }

import { SelfBuildingSquareSpinner  } from 'epic-spinners'

export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SelfBuildingSquareSpinner), {
      "animation-duration": 6000,
      size: 80,
      color: "currentColor"
    })
  ]))
}
}

})